/* eslint-disable class-methods-use-this */
import { DiscountMeasureUnits, DiscountTypes, DiscountUnits } from '@invivodf/module-discount-sdk'
import { BaseDiscountForm } from './BaseDiscountForm'
import { RequiredScale } from './fields/RequiredScale'
import { DISCOUNT_UNITS } from '../constants/DISCOUNT_UNITS'
import { Discount, ISlice } from '../Discount'
import { IDiscountFormProps } from './IDiscountFormProps'
import { DiscountPolicy } from '../DiscountPolicy'

export class DiscountFormWithScale extends BaseDiscountForm {
  public scale: RequiredScale

  public readonly type: DiscountTypes

  constructor(props: IDiscountFormProps) {
    super(props)
    this.scale = new RequiredScale(props.scale || [{ min: null, max: null, discount: null }])
    this.type = props.policy.type
  }

  static initForCreate(policy: DiscountPolicy, isMeta: boolean, sellerId: number) {
    return new DiscountFormWithScale({ policy, isMeta, sellerId })
  }

  static initForUpdate(discount: Discount, sellerId: number) {
    return new DiscountFormWithScale({ ...discount, sellerId })
  }

  static initForDuplicate(discount: Discount, sellerId: number, isDuplicatedActive: boolean = true) {
    return new DiscountFormWithScale({
      ...discount,
      sellerId,
      id: undefined,
      reference: isDuplicatedActive ? undefined : discount.reference,
      participants: undefined,
    })
  }

  public hasErrors(): boolean {
    return this.hasGeneralInformationsErrors() || this.hasScaleErrors() || this.hasPromoCodeErrors()
  }

  private hasScaleErrors() {
    return this.scale.hasErrors()
  }

  public isMeasureUnitSetToAnyAndNotEditable(): boolean {
    return this.unit.validatedValue === DISCOUNT_UNITS[1].value && this.type === DiscountTypes.OnRevenue
  }

  public isMeasureUnitSetToUnitAndNotEditable(): boolean {
    return false
  }

  public isUnitSetToEuroAndNotEditable(): boolean {
    return false
  }

  public toDiscount(): Discount {
    this.validate()
    if (this.hasErrors()) {
      throw new Error(`Can't get a discount from an incomplete form.`)
    }

    return {
      id: this.id ?? '',
      internalName: this.internalName.validatedValue,
      measureUnit: this.measureUnit !== null ? (this.measureUnit.validatedValue as DiscountMeasureUnits) : null,
      discountableList: [],
      discountablesCount: 0,
      publicName: this.publicName.validatedValue,
      reference: this.reference.validatedValue,
      segment: this.segment.validatedValue,
      scale: this.scale.validatedValue as ISlice[],
      unit: this.unit.validatedValue as DiscountUnits,
      validityEndDate: this.validityEndDate.validatedValue ?? null,
      validityStartDate: this.validityStartDate.validatedValue!,
      disabledDate: null,
      promoCode: this.promoCode.validatedValue,
      isFlash: this.isFlash.validatedValue,
      isSales: this.isSales.validatedValue,
      isMeta: this.isMeta,
      nbOverallUsesMax: this.nbOverallUsesMax.validatedValue,
      nbCustomerUsesMax: this.nbCustomerUsesMax.validatedValue,
      policy: new DiscountPolicy(this.type, this.scope),
      groupSize: this.groupSize.validatedValue,
      isExcludedAssociations: this.isExcludedAssociations,
      productsCount: 0,
    }
  }

  validate(): void {
    this.validateGeneralInformations()
    this.scale.validate(this.unit.validatedValue)
  }
}
